/**
 * @author hxliu
 * @date 2020-10-24
 * @description 班级信息弹出
 */
import React from "react";
import moment from "moment";
import { WizClassifySelect, WizTableForm } from '@/containers/common';

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    },
    {
      title: "名称",
      name: "name",
      searchItem: {},
      tableItem: {
        width: 200
      },
    },

    {
      title: "分类",
      name: "categoryId",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          itemProps: {
            icon: 'unordered-list',
            title: '科目分类',
            tips: '请勾选所属科目分类'
          },
          treeProps: { checkStrictly: true },
          checkable: false
        },
        apiProps: { type: 10, state: 1 },
        selectProps: {
          placeholder: '请选择科目分类'
        },
      }
    },

    {
      title: "分类",
      name: "categoryName",
      tableItem: {
        width: 200,
      },
    },

    {
      title: "类型",
      name: "type",
      searchItem: {
        type: 'select'
      },
      tableItem: {
        width: 120
      },
      dict: [
        { code: 1, codeName: '必修' },
        { code: 2, codeName: '选修' }
      ],
    },

    {
      title: "状态",
      name: "state",
      dataIndex: "state",
      dict: [
        { code: 0, codeName: '无效' },
        { code: 1, codeName: '有效' }
      ],
      searchItem: {
        type: 'select'
      },
      tableItem: {
        width: 80,
      },
    },

  ]
}
const tableApi = (api = {}) => {
  return {
    path: 'subject/pageList',
    ...api
  }

}
const subject = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    rowKey: 'id',
    rowName: 'name',
    columns: columns(self),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api),
    searchProps: {
      dataFormat: (v) => {
        let value = Object.assign([], v)
        if (value['categoryId'] && value['categoryId'] instanceof Array) {
          value['categoryId'] = value['categoryId'][0]
        }

        return value
      }
    },
  }
}

export default subject
